import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeCostCenterCreate,
  detail: routeCostCenterDetail,
  home: routeCostCenterHome,
  root: routeCostCenterRoot,
} = createDoctypeRoutes({
  createName: 'new-cost-center',
  createPath: 'new-cost-center',
  detailName: 'costCenterDetail',
  doctype: DOCTYPES.COST_CENTER,
  homeName: 'cost-center',
  path: 'cost-center',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/settings/accounting/costCenter/AddCostCenter.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/settings/accounting/costCenter/ViewCostCenter.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/accounting/ViewAccountingSettings.vue'),
  },
})

export { routeCostCenterCreate, routeCostCenterDetail, routeCostCenterHome, routeCostCenterRoot }
